export default __webpack_public_path__ + "static/赛浓顺罗盖特一般销售条款-30f72b298de3de3aabec61522d627e2f.pdf";